import { createNewApolloClient } from "src/shared/utilities/graphql/newApolloClient";

import createInMemoryCacheConfig from "./createInMemoryCacheConfig";
import createStateRenderer from "./createStateRenderer";

const wrapWithState = ({ feature, reducer, stateOptions } = {}) => {
  const { apolloCacheOptions, apolloClientOptions } = stateOptions ?? {};
  const cacheConfig = createInMemoryCacheConfig({
    apolloCacheOptions
  });
  const apolloClient = createNewApolloClient(apolloClientOptions, cacheConfig);
  const renderer = createStateRenderer({ feature, reducer, apolloClient });

  renderer.client = apolloClient;

  return renderer;
};

export default wrapWithState;
